import React from 'react';
import {_t} from "../../../js/app/common/utils/locale";
import Config from '../../../js/app/main/app/service/config';

export default function render() {
    const isSbBrandingAllowed = Config.get('is_sb_branding_allowed');
    return(
        <footer className="footer">
            <div className="container">
                { isSbBrandingAllowed && <span className="text-muted">{_t('© SimplyBook.me Ltd, 2018-2022')}</span> }
            </div>
        </footer>
    );
}